import * as React from "react";
import { DonutSpinner } from "./loader.styles";

interface LoaderProps {
  color?: string;
  duration?: number;
  size?: number;
  strokeWidth?: number;
}

const Loader: React.FC<LoaderProps> = ({
  color = "#7983ff",
  duration = 1200,
  size = 30,
  strokeWidth = 4,
}) => (
  <DonutSpinner color={color} duration={duration} size={size} strokeWidth={strokeWidth} />
);

export default Loader;
